"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueAtRiskTable = void 0;
var generic_1 = require("../generic");
var React = require("react");
var stringUtils_1 = require("../lib/stringUtils");
var ValueAtRiskTable = (function (_super) {
    __extends(ValueAtRiskTable, _super);
    function ValueAtRiskTable() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ValueAtRiskTable.prototype.computePercent = function (evaluation) {
        if (this.props.var_total == 0)
            return 0;
        return Math.round(evaluation.var / this.props.var_total * 100);
    };
    ValueAtRiskTable.prototype.render = function () {
        var _this = this;
        var evaluations = this.props.evaluations;
        var title = [gettext("Risks")];
        if (this.props.title) {
            title.push(" - ");
            title.push((0, stringUtils_1.capitalizeFirstLetter)(this.props.title));
        }
        return (React.createElement("div", { className: "ValueAtRisk__TableSection" },
            React.createElement("div", { className: "ValueAtRisk__TableContainer" },
                React.createElement("table", { className: "risk-table" },
                    React.createElement("thead", null,
                        React.createElement("tr", { className: "ValueAtRisk__HeaderCell" },
                            React.createElement("th", { className: "ValueAtRisk__HeaderCell--Id risk-table--right-align" }, "#"),
                            React.createElement("th", { className: "ValueAtRisk__HeaderCell--Risk" }, title.join("")),
                            React.createElement("th", { className: "ValueAtRisk__HeaderCell--Var risk-table--right-align" }, gettext("Risk value")),
                            React.createElement("th", { className: "ValueAtRisk__HeaderCell--Percent risk-table--right-align" },
                                "% ",
                                pgettext("% of VaR", "of VaR")))),
                    React.createElement("tbody", null, evaluations.map(function (evaluation, i) {
                        return (React.createElement("tr", { key: i, onClick: function () { return window.open(evaluation.risk_url); } },
                            React.createElement("td", { className: "risk-table--right-align" }, i + 1),
                            React.createElement("td", null,
                                _this.props.cross_project &&
                                    React.createElement(generic_1.ProjectBox, { value: evaluation.project_title }),
                                React.createElement(generic_1.DomainItemBox, { value: gettext("Risk") + " #".concat(evaluation.risk_number), type: 1 }),
                                " ",
                                evaluation.risk_title),
                            React.createElement("td", { className: "risk-table--right-align" }, evaluation.var_precision),
                            React.createElement("td", { className: "risk-table--right-align" },
                                _this.computePercent(evaluation),
                                "%")));
                    })),
                    this.props.sub_total_var && this.props.calc_total_var &&
                        React.createElement("tfoot", null,
                            React.createElement("tr", null,
                                React.createElement("td", null),
                                React.createElement("td", null),
                                React.createElement("td", { className: "risk-table--right-align risk-table--border-top" }, this.props.sub_total_var),
                                React.createElement("td", { className: "risk-table--right-align risk-table--border-top" },
                                    Math.round(this.props.calc_total_var / this.props.var_total * 100) || 0,
                                    "%")))))));
    };
    return ValueAtRiskTable;
}(React.Component));
exports.ValueAtRiskTable = ValueAtRiskTable;
